import { EditIcon } from '@approvalmax/ui';
import { Button, Flex, Label, Tag, Text } from '@approvalmax/ui/src/components';
import { memo, useCallback } from 'react';
import { InfoCard } from 'shared/components';
import { useCompanyBasedOnUrl } from 'shared/hooks/useCompanyBasedOnUrl';
import { usePermissions } from 'shared/hooks/usePermissions';

import { messages } from './PaymentDetails.messages';
import { PaymentDetailsProps } from './PaymentDetails.types';

export const PaymentDetails = memo<PaymentDetailsProps>((props) => {
    const { data, onEdit } = props;

    const {
        isDefault,
        bankAccount: { country, name, accountNumber, currency, sortCode },
    } = data;

    const company = useCompanyBasedOnUrl();

    const { isPaymentDetailsEditEnabled } = usePermissions(company);

    const onEditClick = useCallback(() => {
        onEdit(data.id);
    }, [data.id, onEdit]);

    const countryName = country === 'GB' ? messages.ukCountry : country;

    return (
        <InfoCard
            title={messages.title}
            afterTitle={
                isDefault ? (
                    <Tag color='midnight80' size='xsmall' title={messages.default}>
                        {messages.default}
                    </Tag>
                ) : null
            }
            actions={
                isPaymentDetailsEditEnabled && (
                    <Button color='blue80' size='xsmall' startIcon={<EditIcon />} onClick={onEditClick}>
                        {messages.edit}
                    </Button>
                )
            }
        >
            <Flex spacing='16' justifyContent='space-between'>
                <div>
                    <Label>{messages.bankAccountName}</Label>

                    <Text font='label' fontSize='small'>
                        {name}
                    </Text>
                </div>

                <div>
                    <Label>{messages.sortCode}</Label>

                    <Text font='label' fontSize='small'>
                        {sortCode}
                    </Text>
                </div>

                <div>
                    <Label>{messages.bankAccountNumber}</Label>

                    <Text font='label' fontSize='small'>
                        {accountNumber}
                    </Text>
                </div>

                <div>
                    <Label>{messages.bankAccountCurrency}</Label>

                    <Text font='label' fontSize='small'>
                        {currency}
                    </Text>
                </div>

                <div>
                    <Label>{messages.bankAccountCountry}</Label>

                    <Text font='label' fontSize='small'>
                        {countryName}
                    </Text>
                </div>
            </Flex>
        </InfoCard>
    );
});

PaymentDetails.displayName = 'PaymentDetails';
